import { Modal, useModals } from 'almanac-ui/Modal'
import { TopicConfiguratorForContentTypesProps, TopicRow } from './Types'
import Styles from './TopicConfiguratorForContentTypes.module.scss'
import { CreditUsageButton } from 'blaze-ui/CreditUsageButton/CreditUsageButton'
import { PostRow } from './PostRow'

export const TopicConfiguratorForContentTypes = ({
  topicRows,
  setTopicRows,
  targetSchedule,
  onBack,
  onConfirm,
  isLoading,
  needsCredits,
  creditsNeeded,
}: TopicConfiguratorForContentTypesProps) => {
  const { closeModal } = useModals()

  const topicsStillLoading = topicRows.some((row) => row.loading)

  const updateRow = (id: string, updates: Partial<TopicRow>) => {
    setTopicRows((prev) => prev.map((row) => (row.id === id ? { ...row, ...updates } : row)))
  }

  const removeRow = (id: string) => {
    setTopicRows((prev) => prev.filter((row) => row.id !== id))
  }

  const submitButtonText = needsCredits ? 'Add Credits to Generate' : 'Generate Content'

  return (
    <>
      <Modal.Header title="Review post prompts and adjust as needed" />
      <Modal.Content>
        <div className={Styles.postsList}>
          {topicRows.map((row, index) => {
            return (
              <PostRow
                key={row.id}
                row={row}
                index={index}
                targetSchedule={targetSchedule}
                onUpdateRow={updateRow}
                onRemoveRow={removeRow}
                canRemove={topicRows.length > 1}
              />
            )
          })}
        </div>
      </Modal.Content>
      <Modal.Footer>
        <Modal.FooterContent slot="left">
          <Modal.FooterButton size="lg" variant="tertiary" onPress={onBack || closeModal}>
            {onBack ? 'Back' : 'Cancel'}
          </Modal.FooterButton>
        </Modal.FooterContent>
        <Modal.FooterContent slot="right">
          <CreditUsageButton
            color="var(--light-60)"
            credits={creditsNeeded}
            onPress={onConfirm}
            size="lg"
            isDisabled={isLoading || topicsStillLoading || topicRows.length === 0}
          >
            {isLoading ? 'Generating...' : submitButtonText}
          </CreditUsageButton>
        </Modal.FooterContent>
      </Modal.Footer>
    </>
  )
}
